module.exports = __webpack_public_path__ + "static/media/Kopenhagen_1-1.26220237.jpg";